interface QAItem {
  q: string;
  a: string;
}

interface AIAnswerBlockProps {
  items: QAItem[];
  title?: string;
  subtitle?: string;
  light?: boolean;
}

export default function AIAnswerBlock({ items, title, subtitle, light }: AIAnswerBlockProps) {
  const bg = light ? "bg-gray-50" : "bg-[#030C15]";
  const border = light ? "border-gray-200" : "border-white/6";
  const labelColor = light ? "text-[#0EA5E9]" : "text-[#7DD3FC]";
  const headingColor = light ? "text-gray-900" : "text-white";
  const subColor = light ? "text-gray-500" : "text-white";
  const qColor = light ? "text-gray-900" : "text-white";
  const aColor = light ? "text-gray-600" : "text-white";
  const cardBg = light ? "bg-white border-gray-200" : "bg-[#071220] border-white/6";
  const accentLine = light ? "from-[#0EA5E9] to-[#0EA5E9]/20" : "from-[#0EA5E9] to-[#0EA5E9]/10";

  return (
    <section className={`${bg} py-24`}>
      <div className="max-w-5xl mx-auto px-6">
        {(title || subtitle) && (
          <div className="mb-14 text-center">
            <p className={`font-['Inter'] ${labelColor} text-xs font-semibold uppercase tracking-[0.18em] mb-3`}>
              Quick Answers
            </p>
            {title && (
              <h2 className={`font-['Playfair_Display'] ${headingColor} text-3xl md:text-4xl font-bold mb-3`}>
                {title}
              </h2>
            )}
            {subtitle && (
              <p className={`font-['Inter'] ${subColor} text-base max-w-xl mx-auto`}>{subtitle}</p>
            )}
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {items.map((item, idx) => (
            <div
              key={idx}
              className={`${cardBg} border rounded-2xl p-8 flex flex-col gap-4`}
            >
              <div className="flex items-start gap-3">
                <div className={`w-0.5 self-stretch bg-gradient-to-b ${accentLine} rounded-full flex-shrink-0 min-h-[40px]`}></div>
                <div>
                  <h3 className={`font-['Inter'] ${qColor} font-bold text-base leading-snug mb-3`}>
                    {item.q}
                  </h3>
                  <p className={`font-['Inter'] ${aColor} text-sm leading-[1.85]`}>
                    {item.a}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
